import {
  FAILED_GET_BOOKING,
  FAILED_GET_BOOKINGS,
  FAILED_PERSIST_BOOKING,
  RECEIVE_GET_BOOKING,
  RECEIVE_GET_BOOKINGS,
  RECEIVE_GET_MESSAGES,
  RECEIVE_GET_NEW_BOOKINGS_COUNT,
  RECEIVE_PERSIST_BOOKING,
  REQUEST_PERSIST_BOOKING,
} from 'redux/actions/booking'
import { RESET_STATE } from 'redux/actions/global'

const initialState = {
  form: {
    data: null,
    messages: [],
    error: '',
    fetching: true,
    sending: false,
    deleting: false,
  },
  overview: {
    data: [],
    error: '',
    fetching: true,
    pageNumber: 1,
    totalCount: 0,
  },
  newCount: 0,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FAILED_GET_BOOKING:
    case FAILED_PERSIST_BOOKING:
      return {
        ...state,
        form: {
          ...state.form,
          fetching: false,
          sending: false,
          deleting: false,
        },
      }
    case RECEIVE_PERSIST_BOOKING:
      return {
        ...state,
        form: {
          ...state.form,
          data: {
            ...state.form.data,
            groupSize: action.data.groupSize,
          },
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_BOOKING:
      return {
        ...state,
        form: {
          ...state.form,
          data: action.data,
          fetching: false,
          sending: false,
        },
      }
    case RECEIVE_GET_BOOKINGS:
      return {
        ...state,
        overview: {
          data: action.data,
          fetching: false,
          pageNumber: action.pageNumber,
          totalCount: action.totalCount,
        },
      }
    case RECEIVE_GET_NEW_BOOKINGS_COUNT:
      return {
        ...state,
        newCount: action.data,
      }
    case RECEIVE_GET_MESSAGES:
      return {
        ...state,
        form: {
          ...state.form,
          messages: action.data,
        },
      }
    case REQUEST_PERSIST_BOOKING:
      return {
        ...state,
        form: {
          ...state.form,
          sending: true,
        },
      }
    case RESET_STATE:
      if (action.state === 'booking') {
        return {
          ...state,
          [action.screen]: initialState[action.screen],
        }
      }
    default:
      return state
  }
}
